import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { fitTableTooltipProps } from '../utils/fitTable';
import { rowHasComments, type PersonalTxComment, type PersonalTxCommentRow } from './HouseholdTxCommentThread';

export const txHasComment = (value?: string | null | PersonalTxComment[] | PersonalTxCommentRow) => {
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === 'object') return rowHasComments(value);
  return Boolean((value || '').trim());
};

export const HouseholdTxCommentButton: React.FC<{
  rowId: number;
  comment?: string | null;
  comments?: PersonalTxComment[] | null;
  testIdPrefix: string;
  onClick: () => void;
}> = ({ rowId, comment, comments, testIdPrefix, onClick }) => {
  const hasComment = rowHasComments({ id: rowId, comments, user_comment: comment });
  return (
    <Tooltip title={hasComment ? 'View comments' : 'Add comment'} {...fitTableTooltipProps}>
      <IconButton
        size="small"
        aria-label={hasComment ? `View comments for ${rowId}` : `Add comment for ${rowId}`}
        data-testid={`${testIdPrefix}-comment-${rowId}`}
        data-has-comment={hasComment ? 'true' : 'false'}
        color={hasComment ? 'primary' : 'default'}
        onClick={onClick}
      >
        {hasComment ? <ChatBubbleIcon fontSize="small" /> : <ChatBubbleOutlineIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};
